import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BrListWrapper = styled.div<any>`
  margin: 10px 0;
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    padding: 5px;
    margin: 5px 0;
  }
`;
